import TrashCan from "@assets/images/trash.svg";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import { useUser } from "@saleor/auth";
import Checkbox from "@saleor/components/Checkbox";
import DialogConfirmDelete from "@saleor/components/DialogConfirmDelete";
import MyTypography from "@saleor/components/MyTypography";
import NumberFormat from "@saleor/components/NumberFormat/NumberFormat";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import Skeleton from "@saleor/components/Skeleton";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { STAFF_UPDATE } from "@saleor/config";
import { orderDetailUrl } from "@saleor/createOrder/urls";
import {
  DeleteCustomerCartItemsMutation,
  useCustomerCartProductVariantQuery,
  useCustomerCartQuery,
  useCustomerCartTotalsQuery,
  useDeleteCustomerCartItemsMutation,
  useUpdateCustomerCartLinesMutation
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import useNavigator from "@saleor/hooks/useNavigator";
import { convertToRol } from "@saleor/utils/data/convertUnit";
import isEmpty from "lodash/isEmpty";
import lodash_orderBy from "lodash/orderBy";
import lodash_remove from "lodash/remove";
// import { mapNodeToChoice } from "@saleor/utils/maps";
import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import useRouter from "use-react-router";

import DrawAddProduct from "../DrawAddProduct/DrawAddProduct";
import BottomBar from "./BottomBar";
import BoxInfoContract from "./BoxInfoContract";
import useStyles, { bottomFixed } from "./styles";

interface ShoppingCartDetailProps {
  cartId: string;
  onSubmitCart: (data, customerId) => void;
}

interface dataDialogDeleteProps {
  title: string | React.ReactNode;
  content: string | React.ReactNode;
  lines: string[];
}

const ShoppingCartDetailCustomer: React.FC<ShoppingCartDetailProps> = props => {
  const { cartId, onSubmitCart } = props;
  const { history } = useRouter();
  const [data, setData] = useState(null);
  const [listLineState, setListLineState] = useState<any[]>([]);
  const [checkboxStateBackup, setCheckboxStateBackup] = useState<any[]>([]);
  const [openConfrmDelete, setOpenConfirmDelete] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [skipCartInfo, setSkipCartInfo] = useState<boolean>(true);
  const [dataDialogDelete, setDataDialogDelete] = useState<
    dataDialogDeleteProps
  >({
    title: "",
    content: "",
    lines: []
  });
  const [openDrawAddProduct, setOpenDrawAddProduct] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigator();
  const intl = useIntl();
  const { soldToId } = useUser();
  const {
    data: baseData,
    loading: loadingData,
    refetch
  } = useCustomerCartQuery({
    variables: {
      cartId
    },
    skip: !cartId,
    fetchPolicy: "no-cache"
  });
  const {
    data: masterData,
    refetch: refetchVariant
  } = useCustomerCartProductVariantQuery({
    variables: {
      id: cartId
    },
    skip: !cartId,
    fetchPolicy: "no-cache"
  });
  const {
    data: cartInfoData,
    refetch: refetchCart
  } = useCustomerCartTotalsQuery({
    skip: skipCartInfo,
    variables: {
      soldToId
    },
    fetchPolicy: "no-cache"
  });

  const handleOnCompleted = async (data: DeleteCustomerCartItemsMutation) => {
    if (!data.deleteCustomerCartItems.errors.length) {
      const listLineStateClone = [...listLineState];
      dataDialogDelete.lines.forEach(lineId => {
        lodash_remove(listLineStateClone, { id: lineId });
      });
      await refetchCart();
      setListLineState([...listLineStateClone]);
    }
  };
  const [deleteCartItems] = useDeleteCustomerCartItemsMutation({
    onCompleted: data => {
      handleOnCompleted(data);
    }
  });

  const [appState, dispatchAppState] = useAppState();
  const { expandMenu } = appState;

  const totalTimer = 700; // delay typing 700ms
  const [timerId, setTimerId] = useState<NodeJS.Timeout>();

  const [updateCustomerCartLines] = useUpdateCustomerCartLinesMutation();

  useEffect(() => {
    if (!isEmpty(baseData) && !isEmpty(masterData)) {
      if (!baseData.customerCart) {
        setData({ customerCart: null });
        return;
      }
      const {
        customerCart: { cartItems, ...rest }
      } = baseData;
      const {
        customerCartProductVariant: { contractProduct }
      } = masterData;
      const newCartItems = cartItems.map(cartItem => ({
        ...cartItem,
        contractProduct: contractProduct.find(
          contract => contract.id === cartItem.contractProductId
        )
      }));
      setData({ customerCart: { ...rest, cartItems: newCartItems } });
    }
  }, [baseData, masterData]);

  useEffect(() => {
    if (!loadingData) {
      if (data?.customerCart) {
        const listLine =
          data.customerCart?.cartItems.map(item => {
            const limitQuantity = item?.variant?.limitQuantity || 0;
            const quantity = item.quantity;
            return {
              ...item,
              selected: true,
              variant: { ...item.variant, writable: true },
              errorQuantity: !quantity || quantity > limitQuantity
            };
          }) || [];

        const sortingListLine = lodash_orderBy(listLine, "id", "asc");
        setListLineState(sortingListLine);
      } else {
        navigate(orderDetailUrl(""));
      }
    }
  }, [data]);

  useEffect(() => {
    if (cartInfoData) {
      const orderCount = cartInfoData.customerCartTotals?.totalProducts || 0;
      dispatchAppState({
        payload: {
          orderCount
        },
        type: "setOrderCount"
      });
    }
  }, [cartInfoData]);

  const classes = useStyles({ expandMenu });

  const getChoices = item => {
    const listChoices = item.contractProduct.product.variants.map(item => ({
      label: item.descriptionEn,
      value: item.id,
      salesUnit: item.salesUnit,
      limitQuantity: item.limitQuantity
    }));
    const lineSameProduct = listLineState
      .filter(
        line =>
          line.contractProduct.product.id === item.contractProduct.product.id
      )
      .filter(line => line.id !== item.id);
    const alreadySelect = lineSameProduct.map(line => line.variant.id);
    listChoices.forEach(choice => {
      if (alreadySelect.indexOf(choice.value) >= 0) {
        choice.disabled = true;
      }
    });

    return listChoices;
  };

  const getTotalQuantityMat84 = lineChanged => {
    let total = 0;

    listLineState.forEach(line => {
      if (line.contractProduct.product.materialType === "84") {
        const filteredLine = line.contractProduct.product.variants.filter(
          variant => variant.id === line.variant.id
        );

        if (
          line.selected &&
          line.contractProductId === lineChanged.contractProductId
        ) {
          const matWeight = filteredLine[0]?.weight || 1;

          if (line.variant.id === lineChanged.variant.id) {
            total += lineChanged.quantity * matWeight;
          } else {
            total += line.quantity * matWeight;
          }
        }
      }
    });

    return total;
  };

  const getTotalQuantityMat8182 = lineChanged => {
    let total = 0;
    listLineState.forEach(line => {
      if (line.contractProduct.product.materialType !== "84") {
        if (
          line.contractProduct.id === lineChanged.contractProduct.id &&
          line.selected
        ) {
          const matWeight =
            line?.contractProduct?.product?.variants[0]?.weight || 1;
          total += lineChanged.quantity * matWeight;
        }
      }
    });

    return total;
  };

  const onChangeChoices = (lineId, event, choice) => {
    clearTimeout(timerId);

    const { limitQuantity, salesUnit } = choice;
    const choiceId = event.target.value;
    const lines = [...listLineState];
    const lineChange = lines.find(item => item.id === lineId);
    const remainingQuantity = lineChange.contractProduct.remainingQuantity || 0;

    lineChange.variant.id = choiceId;
    lineChange.variant.salesUnit = salesUnit;

    const totalMat8182 = getTotalQuantityMat8182(lineChange);
    const totalMat84 = getTotalQuantityMat84(lineChange);

    if (lineChange.selected) {
      if (lineChange.contractProduct.product.materialType === "84") {
        lineChange.errorQuantity = totalMat84 > remainingQuantity;
      } else {
        lineChange.errorQuantity = totalMat8182 > remainingQuantity;
      }
    }

    setListLineState(
      lines.map(item => {
        if (item.id === lineId) {
          return {
            ...item,
            variant: {
              ...item.variant,
              salesUnit,
              limitQuantity
            }
          };
        }
        return item;
      })
    );

    const newLines = lines.map(line => ({
      id: line.id,
      quantity: line.quantity,
      materialVariantId: line.variant.id
    }));

    if (parseInt(lineChange.quantity, 10)) {
      const newTimerId = setTimeout(() => {
        updateCustomerCartLines({
          variables: {
            id: cartId,
            input: {
              lines: newLines
            }
          }
        });
      }, totalTimer);

      setTimerId(newTimerId);
    }
  };

  const onChangeQuantity = (lineId, event) => {
    clearTimeout(timerId);

    const lines = [...listLineState];
    const lineChange = lines.find(line => line.id === lineId);
    const quantity = event.target.value;
    const remainingQuantity = lineChange.contractProduct.remainingQuantity || 0;
    lineChange.quantity = parseFloat(quantity);

    if (quantity) {
      lineChange.selected = true;
    }

    const totalMat8182 = getTotalQuantityMat8182(lineChange);
    const totalMat84 = getTotalQuantityMat84(lineChange);

    if (parseFloat(quantity)) {
      if (lineChange.contractProduct.product.materialType === "84") {
        lineChange.errorQuantity = totalMat84 > remainingQuantity;
      } else {
        lineChange.errorQuantity = totalMat8182 > remainingQuantity;
      }
    } else {
      lineChange.errorQuantity = true;
    }

    setListLineState(lines);

    const newLines = lines.map(line => ({
      id: line.id,
      quantity: line.quantity,
      materialVariantId: line.variant.id
    }));

    if (parseInt(quantity, 10)) {
      const newTimerId = setTimeout(() => {
        updateCustomerCartLines({
          variables: {
            id: cartId,
            input: {
              lines: newLines
            }
          }
        });
      }, totalTimer);

      setTimerId(newTimerId);
    }
  };

  const onChangeCheckItem = (lineId: string, event) => {
    const lines = [...listLineState];
    const lineChange = lines.find(item => item.id === lineId);
    const quantity = lineChange.quantity;
    const checked = event.target.checked;
    const remainingQuantity = lineChange.contractProduct.remainingQuantity || 0;

    lineChange.selected = checked;

    const totalMat8182 = getTotalQuantityMat8182(lineChange);
    const totalMat84 = getTotalQuantityMat84(lineChange);

    if (checked) {
      if (lineChange.contractProduct.product.materialType === "84") {
        lineChange.errorQuantity = totalMat84 > remainingQuantity;
      } else {
        lineChange.errorQuantity = totalMat8182 > remainingQuantity;
      }
    } else {
      lineChange.errorQuantity = false;
    }

    if (!quantity) {
      lineChange.errorQuantity = checked;
    }

    setListLineState(lines);
  };

  const onClickCheckHeader = () => {
    const lines = [...listLineState];
    const listSelected = getSelectedLine();
    if (listSelected.length < listLineState.length) {
      lines.forEach(line => {
        line.selected = true;
        const limitQuantity = line?.variant?.limitQuantity || 0;
        const quantity = line.quantity;
        line.errorQuantity = !quantity || quantity > limitQuantity;
      });
    } else if (listSelected.length === listLineState.length) {
      lines.forEach(item => {
        item.selected = false;
        item.errorQuantity = false;
      });
    }
    setListLineState(lines);
  };

  const getSelectedLine = () => listLineState.filter(item => item.selected);

  const getCheckedHeader = () => listLineState.every(item => item.selected);

  const isSomeLineErrorQuantity = () =>
    listLineState.some(item => item.errorQuantity);

  const getIndeterminateHeader = () => {
    const listSelectedLength = getSelectedLine().length;
    return listSelectedLength > 0 && listSelectedLength < listLineState.length;
  };

  const confirmDelete = async () => {
    setLoading(true);
    setOpenConfirmDelete(false);
    try {
      setSkipCartInfo(false);
      await deleteCartItems({
        variables: {
          cartItemIds: dataDialogDelete.lines
        }
      });
      await refetch();
      await refetchCart();
      setLoading(false);
      const isRemoveAll =
        listLineState.length === dataDialogDelete.lines.length;
      if (isRemoveAll) {
        history.goBack();
      }
    } catch {
      setLoading(false);
    } finally {
      setSkipCartInfo(true);
    }
  };

  const getDisableSubmit = () => {
    const listSelected = getSelectedLine();

    if (listSelected?.length <= 0 || isSomeLineErrorQuantity()) {
      return true;
    }

    return false;
  };

  const onClickSubmitBottom = () => {
    const listSelected = getSelectedLine();

    const dataSubmit = {
      detailId: data.customerCart.id,
      contractId: data.customerCart.contract.id,
      userId: data.customerCart.id,
      lines: listSelected.map(item => ({
        contractProductId: item.contractProduct.id,
        id: item.id,
        quantity: item.quantity,
        variantId: item.variant.id,
        selected: item.selected
      }))
    };

    const contractId = data?.customerCart?.contract?.id;
    onSubmitCart(dataSubmit, contractId);
  };

  const setDeleteSingle = lineId => {
    setCheckboxStateBackup(JSON.parse(JSON.stringify(listLineState)));

    setListLineState(
      listLineState.map(i => ({
        ...i,
        selected: lineId === i.id ? true : false
      }))
    );
    setDataDialogDelete({
      lines: [lineId],
      title: "ลบรายการนี้",
      content: "คุณกำลังจะลบรายการสินค้านี้"
    });
    setOpenConfirmDelete(true);
  };

  const setDeleteSelected = () => {
    setCheckboxStateBackup(JSON.parse(JSON.stringify(listLineState)));
    const lineSelected = getSelectedLine().map(line => line.id);
    const content = (
      <span>
        คุณกำลังจะลบสินค้า <b>{lineSelected.length}</b> รายการ ในตะกร้านี้
      </span>
    );
    setDataDialogDelete({
      lines: lineSelected,
      title: "ลบรายการสินค้าที่เลือก",
      content
    });
    setOpenConfirmDelete(true);
  };

  const refetchData = () => {
    refetch();
  };

  const textError = intl.formatMessage({
    defaultMessage: "จำนวนที่สั่งมีมากกว่าจำนวนคงเหลือ"
  });

  const textErrorEmpty = intl.formatMessage({
    defaultMessage: "กรุณาระบุจำนวน"
  });

  const isMatType84 = product => product?.materialType === "84";

  if (!data) {
    return null;
  }

  const onAddMoreProduct = () => {
    setOpenDrawAddProduct(true);
  };

  return (
    <>
      <BoxInfoContract data={data} />
      <div className={classes.tableProduct}>
        <div className={classes.tableTitle}>
          <MyTypography variant={"body2"}>
            <FormattedMessage defaultMessage={"รายการสินค้า"} /> (
            {listLineState.length})
          </MyTypography>
        </div>
        <div className={classes.root} ref={containerRef}>
          {listLineState.length ? (
            <Table className={classes.mainTable}>
              <TableHead>
                <TableRow>
                  <TableCellHeader style={{ minWidth: 50 }}>
                    <Checkbox
                      size={"small"}
                      onClick={onClickCheckHeader}
                      checked={getCheckedHeader()}
                      indeterminate={getIndeterminateHeader()}
                    />
                  </TableCellHeader>
                  <TableCellHeader style={{ minWidth: 120 }}>
                    <FormattedMessage defaultMessage={"ช่ือสินค้า"} />
                  </TableCellHeader>
                  <TableCellHeader style={{ minWidth: 400 }}>
                    <FormattedMessage defaultMessage={"รายละเอียดสินค้า"} />
                  </TableCellHeader>
                  <TableCellHeader style={{ minWidth: 100 }}>
                    <FormattedMessage defaultMessage={"จำนวน"} />
                  </TableCellHeader>
                  <TableCellHeader
                    style={{ minWidth: 100 }}
                    textAlign={"center"}
                  >
                    <FormattedMessage defaultMessage={"หน่วย"} />
                  </TableCellHeader>
                  <TableCellHeader
                    style={{ minWidth: 100 }}
                    textAlign={"center"}
                  >
                    <FormattedMessage defaultMessage={"ลบ"} />
                  </TableCellHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {listLineState.length ? (
                  listLineState.map((item, index) => (
                    <TableRow key={item.id} className={classes.tableRow}>
                      <TableCell>
                        <Checkbox
                          size={"small"}
                          checked={item.selected}
                          onChange={e => onChangeCheckItem(item.id, e)}
                        />
                      </TableCell>
                      <TableCell className={classes.colProductName}>
                        {item?.contractProduct?.materialDescription}
                      </TableCell>
                      <TableCell>
                        {getChoices(item)?.length === 0 ? (
                          <Skeleton />
                        ) : isMatType84(item.contractProduct?.product) ? (
                          <SingleSelectField
                            id={`lines[${index}].product`}
                            choices={getChoices(item)}
                            onChange={(e, choice) => {
                              onChangeChoices(item.id, e, choice);
                            }}
                            value={item.variant.id}
                          />
                        ) : null}
                      </TableCell>
                      <TableCell>
                        <NumberFormat
                          id={`lines[${index}].quantity`}
                          error={item.errorQuantity}
                          placeholder={"ระบุจำนวน"}
                          onChange={e => onChangeQuantity(item.id, e)}
                          value={item.quantity?.toString()}
                          decimalScale={0}
                          allowLeadingZeros
                        />
                        {item.errorQuantity && item.quantity ? (
                          <div className={classes.textError}>{textError}</div>
                        ) : (
                          ""
                        )}
                        {item.errorQuantity && !item.quantity ? (
                          <div className={classes.textError}>
                            {textErrorEmpty}
                          </div>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell
                        align={"center"}
                        className={classes.customerName}
                      >
                        {convertToRol(item.variant?.salesUnit)}
                      </TableCell>
                      <TableCell align={"center"} className={classes.colTrash}>
                        <button
                          id={`lines[${index}].removeButton`}
                          onClick={() => setDeleteSingle(item.id)}
                        >
                          <img src={TrashCan} alt="trash-icon" />
                        </button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <Skeleton />
                )}
              </TableBody>
            </Table>
          ) : (
            ""
          )}
          {listLineState?.length ? (
            <StickyHorizontalScrollBar
              container={containerRef}
              bottom={bottomFixed + 10}
            />
          ) : null}
        </div>
      </div>
      <BottomBar
        selectedLine={getSelectedLine().length}
        disabled={getDisableSubmit() || loading}
        onClick={onAddMoreProduct}
        onSubmit={onClickSubmitBottom}
        onDeleteClick={setDeleteSelected}
      />
      <DialogConfirmDelete
        onConfirm={confirmDelete}
        onCancel={() => {
          setOpenConfirmDelete(false);
          setListLineState(checkboxStateBackup);
        }}
        open={openConfrmDelete}
        title={dataDialogDelete.title}
        content={dataDialogDelete.content}
      />
      <DrawAddProduct
        customerCart={data}
        cartData={listLineState}
        open={openDrawAddProduct}
        onClose={() => setOpenDrawAddProduct(false)}
        contractId={data?.customerCart?.contract?.id}
        refetchData={() => {
          refetchData();
          refetchVariant();
        }}
        cartId={cartId}
        staffUpdate={STAFF_UPDATE.UPDATE_CART}
        title={intl.formatMessage({ defaultMessage: "เพิ่มรายการสินค้า" })}
        subTitle={intl.formatMessage({ defaultMessage: "ตะกร้าของฉัน" })}
        isCustomerCreateFlow={true}
      />
    </>
  );
};

export default ShoppingCartDetailCustomer;
